import { Country, getCountryCallingCode } from "react-phone-number-input";

import styles from "./CountryDialCode.module.scss";

interface CountryDialCodeProps {
  country: Country;
}

export const CountryDialCode = ({ country }: CountryDialCodeProps) => {
  if (!country) {
    return null;
  }

  return (
    <span className={styles.dialCode}>+{getCountryCallingCode(country)}</span>
  );
};
